import styled from "styled-components";

export const ModalLoadingTextBox = styled.div`
  padding: 8px 12px;
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
  background: ${(props) => props.theme.colors.primary5};
  border-radius: 6px;
`;
